import React, { ReactNode, useEffect, useRef, useState } from 'react';

import { Box, Stack, Text } from '@chakra-ui/react';

interface Props {
  children: ReactNode;
  noOfLines?: number;
  expandedMaxHeight?: string | number;
}

export const ExpandableText = (props: Props) => {
  const { children, noOfLines = 6, expandedMaxHeight } = props;
  const textRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = textRef.current;

    if (element && !expanded) {
      setIsOverflowing(element.scrollHeight > element.clientHeight);
    }
  }, [children, expanded, noOfLines]);

  const toggleExpanded = () => setExpanded(value => !value);

  return (
    <Stack spacing={0}>
      <Box
        maxH={expanded ? expandedMaxHeight : undefined}
        overflowY={expanded && expandedMaxHeight ? 'auto' : undefined}
      >
        <Box ref={textRef} noOfLines={expanded ? undefined : noOfLines}>
          {children}
        </Box>
      </Box>

      {isOverflowing && (
        <Text
          aria-expanded={expanded}
          fontWeight="semibold"
          color="primary"
          cursor="pointer"
          fontSize="sm"
          onClick={toggleExpanded}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              toggleExpanded();
            }
          }}
          role="button"
          tabIndex={0}
        >
          {expanded ? 'View Less' : 'View More'}
        </Text>
      )}
    </Stack>
  );
};
